import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet-async';
import WithSearchControls from 'search/controls/WithSearchControls';
import SearchTermToggle from 'search/controls/SearchTermToggle';
import SearchInput from 'search/controls/SearchInput';
import SearchActions from 'search/controls/SearchActions';

function NotFound({
    isMobile,
    isSearching,
    isMonthly,
    isCanadaEnabled,
    isValidStart,
    onInputChange,
    onSubmit,
    onSearchClick,
}) {
    return (
        <div className="NotFound">
            <Helmet>
                <title>D&apos;oh! This page doesn&apos;t exist.</title>
                <body className="standalone-page" />
            </Helmet>
            <div className="NotFound-hero">
                <h1 className="NotFound-error-code">404</h1>
                <div className="NotFound-content-wrap">
                    <div className="NotFound-content">
                        <h2 className="NotFound-error-message">
                            Looks like you made a wrong turn.
                            <br />
                            This page doesn&apos;t exist, but you can still get
                            parking below.
                        </h2>
                        <div className="NotFound-search-controls">
                            <SearchTermToggle isSearching={isSearching} />
                            <SearchInput
                                isMonthly={isMonthly}
                                isSearching={isSearching}
                                isCanadaEnabled={isCanadaEnabled}
                                onChange={onInputChange}
                                onSubmit={onSubmit}
                            />
                            <SearchActions
                                addKeyListeners={!isMobile}
                                isSearching={isSearching}
                                isValidStart={isValidStart}
                                onSearchClick={onSearchClick}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

NotFound.propTypes = {
    isMobile: PropTypes.bool,
    isSearching: PropTypes.bool,
    isMonthly: PropTypes.bool,
    isCanadaEnabled: PropTypes.bool,
    isValidStart: PropTypes.bool,
    onInputChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onSearchClick: PropTypes.func,
};

export default WithSearchControls(NotFound);
